import {Component, OnInit} from '@angular/core';
import {MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatRadioModule} from "@angular/material/radio";
import {MatFormFieldModule, MatHint, MatLabel} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {PropertyInactivation} from "../../../domain/models/property-inactivation.model";
import {MatNativeDateModule, provideNativeDateAdapter} from "@angular/material/core";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-inactivate-dialog',
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [MatDialogModule, MatButtonModule, MatIconModule,
    MatRadioModule, MatFormFieldModule, MatInputModule, MatLabel,
    ReactiveFormsModule, MatDatepickerModule, MatHint,
    MatNativeDateModule, CommonModule, FormsModule],
  templateUrl: './inactivate-dialog.component.html',
  styleUrl: './inactivate-dialog.component.css'
})
export class InactivateDialogComponent implements OnInit {
  inactivateForm!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<InactivateDialogComponent>) {
  }

  buildForm(){
    this.inactivateForm = this.fb.group({
      reason: ['', Validators.required],
      lastRented: ['', Validators.required],
      comments: [''],
    });
  }

  private getInactivateFormValues(): PropertyInactivation{
    let fromValues = this.inactivateForm.value;
    return {
      reason: fromValues.reason,
      lastRented: fromValues.lastRented,
      comments: fromValues.comments,
    } as PropertyInactivation;
  }

  inactivate(): void {
    if(this.inactivateForm.valid) {
      let data = this.getInactivateFormValues();
      this.dialogRef.close(data);
    }
  }

  ngOnInit(): void {
    this.buildForm();

  }
}
